<template>
  <div class="long-value-box">
    <div v-if="!expanded" class="box d-flex align-center">
      <v-tooltip
        bottom
        transition="custom-tooltip"
        max-width="none"
        open-delay="150"
        close-delay="0"
      >
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on" class="value-wrapper">
            <span class="value" :class="{ monospace: monospace }">
              {{ value }}
            </span>
          </div>
        </template>
        <span class="p-2" :class="{ monospace: monospace }">{{ value }}</span>
      </v-tooltip>

      <copy-text-button
        v-if="canCopy"
        :text="value"
        :color="copyColor"
        size="24"
      />

      <v-btn
        v-if="canExpand"
        text
        small
        color="primary"
        class="ml-2"
        @click="expanded = true"
      >
        {{ $t("button.more") }}
      </v-btn>
    </div>

    <div v-else class="expanded">
      <v-textarea
        :value="value"
        readonly
        outlined
        auto-grow
        hide-details
        class="textarea"
        :class="{ monospace: monospace }"
      >
        <template v-slot:append-outer>
          <copy-text-button
            v-if="canCopy"
            :text="value"
            :color="copyColor"
            size="24"
          />
        </template>
      </v-textarea>

      <div class="d-flex justify-end mt-2">
        <v-btn text small color="primary" @click="expanded = false">
          {{ $t("button.close") }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import CopyTextButton from "@/components/buttons/CopyTextButton.vue";

export default {
  name: "LongValueBox",
  components: { CopyTextButton },
  props: {
    value: {
      type: String,
      default: "",
    },
    monospace: {
      type: Boolean,
      default: true,
    },
    canCopy: {
      type: Boolean,
      default: true,
    },
    canExpand: {
      type: Boolean,
      default: true,
    },
    copyColor: {
      type: String,
      default: "primary",
    },
  },
  data: function () {
    return {
      expanded: false,
    };
  },
  watch: {
    value: function () {
      this.expanded = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  background: rgba(7, 192, 126, 0.05);
  border-radius: 6px;
  padding: 12px 12px;
  border: 1px solid rgba(7, 192, 126, 0.12);
}

.value-wrapper {
  flex: 1;
  min-width: 0;
}

.value {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--v-primary-base);
  font-weight: $font-weight-bold;
}

.textarea::v-deep {
  .v-input__slot {
    border-radius: 6px;
  }
}

.monospace {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
  letter-spacing: 0.2px;
}
</style>
